// @flow
import { Badge, Tooltip } from "antd";
import {
	BotView,
	InfoContainer,
	TitleWrapper,
	TopView,
	Wrapper,
} from "./TicketScreenCard.styles";
import { Spacer } from "views/components/common/Spacer";
import { dateToString } from "lib/date";
import React from "react";

import { AttentionLabel } from "views/mobile/components/ReservationScreenCard/AttentionLabel";
import { ConfirmationLabel } from "views/components/ConfirmationLabel";
import { Typography } from "antd";
import { WizzardButton } from "views/components/WizzardButton";
import { pathOr } from "ramda";
import { useDispatch } from "reactn";
import { useHistory } from "react-router";
import config from "network/config";

import Info from "views/mobile/components/cards/Info";
import moment from "moment-timezone";
const { Title } = Typography;
const { apiOrigin } = config;

export const ReservationCard = ({
	office,
	line,
	dowloadTicketAction,
	reservation,
	code,
	onClick,
	reservationCofirmed,
	activeMeetButton,
	goToMeet,
	userConfirmed,
	name,
	token,
}) => {
	const history = useHistory();
	const title = `Tu número de reserva:`;

	const isVideoCall = pathOr(false, ["meet"], reservation);
	const reservationAttended = pathOr(false, ["attended"], reservation);
	const timezone = pathOr("America/Santiago", ["timezone"], office);
	const isBetaMeetActive = pathOr(
		"zeroq",
		["options", "betaMeetIsActive"],
		office
	);
	const allowOldIdReservation = pathOr(
		false,
		["options", "allowOldIdReservations"],
		office
	);
	const isAllowRervationsV3 = pathOr(
		false,
		["options", "isAllowRervationsV3"],
		office
	);

	const officeSlug = pathOr(false, ["slug"], office);

	const reservationId = pathOr(false, ["id"], reservation);

	const handleVideoCall = (betaMeet, token, officeSlug, reservationId) => {
		if (betaMeet) {
			window.open(
				`${apiOrigin}/meet/verify/${token}?tuid=${reservationId}&officeSlug=${officeSlug}`,
				"_blank"
			);
			return;
		}
		goToMeet(reservationId);
	};

	const attentionType = isVideoCall ? "Videollamada" : "Presencial";
	const date = dateToString(reservation.from);
	const time =
		reservation &&
		reservation.from &&
		moment(reservation.from).tz(timezone).format("H:mm [hrs]");

	const type = "reservation";

	const handleSetOldIdReservation = useDispatch("handleSetOldIdReservation");

	const goToRereservationScreen = () => {
		handleSetOldIdReservation(reservationId);
		history.push(`/offices/${officeSlug}/${line.slug}/reservation`);
	};

	return (
		<>
			<TitleWrapper>
				<Title level={5}>
					Reserva de atención{" "}
					{attentionType === "Videollamada" && "por"} {attentionType}·
				</Title>
				<ConfirmationLabel
					reservationCofirmed={reservationCofirmed}
					reservationAttended={reservationAttended}
					userConfirmed={userConfirmed}
				/>
			</TitleWrapper>

			<Wrapper>
				<TopView>
					<Spacer rows={1} />
					<h4 className="officeName">{office.name}</h4>
					<Spacer rows={0.5} />
					{isVideoCall && (
						<>
							<WizzardButton
								type={"primary"}
								label={"Ingresar a la videollamada"}
								onClick={() =>
									handleVideoCall(
										isBetaMeetActive,
										token,
										officeSlug,
										reservationId
									)
								}
								disabled={!activeMeetButton}
							/>
							<Spacer rows={0.5} />
							{!activeMeetButton && (
								<p className={"link-meet-button-text"}>
									Se habilitará el ingreso 15 min antes
								</p>
							)}
						</>
					)}
					<InfoContainer>
						<AttentionLabel
							type="attention"
							label={attentionType}
							desktop
						/>

						<AttentionLabel desktop type="date" label={date} />

						<AttentionLabel type="time" label={time} desktop />
					</InfoContainer>
					{/* <p className="date__container">{ticketDate}</p> */}
				</TopView>

				<BotView reservationConfirmed={reservationCofirmed}>
					<Info title={title} body={code} position="left" />

					<div>
						<span className="line__title">Trámite: </span>
						<p className="line__name">
							{(typeof line === "string"
								? line
								: line && line.name) ||
								name ||
								"Sin información"}
						</p>
					</div>
					{!userConfirmed && (
						<div style={{ width: "100%" }}>
							<WizzardButton
								onClick={() =>
									dowloadTicketAction(
										line,
										reservation,
										date,
										type,
										office.name,
										time
									)
								}
								loading={false}
								type={"backgroundWhite"}
								label="Descargar Reserva"
							/>
							{allowOldIdReservation && isAllowRervationsV3 && (
								<>
									<Spacer size={8} />
									<WizzardButton
										onClick={goToRereservationScreen}
										type={"backgroundless"}
										label="Reagendar reserva"
									/>
								</>
							)}
							<Spacer size={8} />
							<WizzardButton
								onClick={onClick}
								type={"backgroundless"}
								label="Cancelar Reserva"
							/>
						</div>
					)}
				</BotView>
			</Wrapper>
		</>
	);
};

const statusDict = {
	processing: "En espera de atención...",
	success: "Ticket atendido",
};

const Status = ({ status }) => {
	return (
		<Tooltip title={statusDict[status]}>
			<Badge status={status} />
		</Tooltip>
	);
};
